import { useEffect } from 'react';

export const useAnalytics = () => {
  useEffect(() => {
    // Track page view when component mounts
    if (window.gtag) {
      window.gtag('config', 'G-HRK1FYTLZG', {
        page_title: document.title,
        page_location: window.location.href,
        page_path: window.location.pathname,
      });
    }
  }, []);

  const trackEvent = (action, category, label, value) => {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }
  };

  return { trackEvent };
};

export default useAnalytics;